export default __webpack_public_path__ + "6cbd7506663db5f7c175101a0d35e2ea.wasm";